import { useState } from "react"
import Button from "../../../components/Button"
import InputText from "../../../components/InputText"
import TextArea from "../../../components/TextArea"
import { useAppDispatch, useAppSelector } from "../../../store/store"
import { createAwardService } from "../../../services/awards.services"
import { addAward } from "../../../store/features/awardsSlice"
import { toast } from "react-toastify"

const CreateAwardForm = () => {
    const token = useAppSelector(state => state.token)
    const dispatch = useAppDispatch()

    const [requesting, setRequesting] = useState<boolean>(false)
    const [data, setData] = useState({
        name: "",
        code: "",
        description: ""
    })

    const handleChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => setData({ ...data, [event.target.name]: event.target.value })

    const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault()
        setRequesting(true)

        createAwardService({ ...data, token: token || '' })
            .then((res) => {
                dispatch(addAward(res.data.payload.award))
                toast.success(res.data.message)
                setData({ name: "", description: "", code: "" })
            })
            .catch((error) => toast.error(error.response.data.message))
            .finally(() => setRequesting(false))
    }

    return (
        <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
            <InputText
                type="text"
                name="name"
                placeholder="Nombre del premio"
                onChange={handleChange}
                value={data.name}
            />
            <InputText
                type="text"
                name="code"
                placeholder="Código del premio para el Back End"
                onChange={handleChange}
                value={data.code}
            />

            <TextArea
                name="description"
                placeholder="Descripción del premio"
                onChange={handleChange}
                rows={6}
                value={data.description}
            >
                {/* {data.description} */}
            </TextArea>

            <Button spinner={requesting} disabled={requesting}>Crear</Button>
        </form>
    )
}

export default CreateAwardForm